export function sortBySortOrder (list = []) {
  return list.slice().sort((a, b) => Number(a.sortOrder || 0) - Number(b.sortOrder || 0))
}

export function parseSnapshot (snapshot) {
  if (!snapshot) {
    return {}
  }
  try {
    return typeof snapshot === 'string' ? JSON.parse(snapshot) : snapshot
  } catch (error) {
    return {}
  }
}

function getFieldValueMap (fields = []) {
  return fields.reduce((result, field) => {
    if (field.fieldCode) {
      result[field.fieldCode] = field.fieldValue
    }
    return result
  }, {})
}

function splitExpression (expression, operator) {
  const result = []
  let bracketLevel = 0
  let segment = ''
  for (let index = 0; index < expression.length; index += 1) {
    const current = expression[index]
    const next = expression[index + 1]
    if (current === '(') bracketLevel += 1
    if (current === ')') bracketLevel -= 1
    if (bracketLevel === 0 && current === operator[0] && next === operator[1]) {
      result.push(segment)
      segment = ''
      index += 1
      continue
    }
    segment += current
  }
  if (segment) {
    result.push(segment)
  }
  return result
}

function trimBracket (value) {
  const result = String(value || '').trim()
  if (result.startsWith('(') && result.endsWith(')')) {
    return result.slice(1, -1).trim()
  }
  return result
}

function evaluateSimpleExpression (expression, fieldValueMap) {
  const match = trimBracket(expression).match(/^([A-Za-z0-9_]+)\s*(==|!=|=)\s*['"]?([^'"]+)['"]?$/)
  if (!match) {
    return true
  }
  const [, fieldCode, operator, expectedValue] = match
  const currentValue = fieldValueMap[fieldCode]
  if (operator === '!=') {
    return String(currentValue || '') !== expectedValue
  }
  return String(currentValue || '') === expectedValue
}

function evaluateVisibilityExpression (expression, fieldValueMap) {
  const currentExpression = trimBracket(
    String(expression || '')
      .replace(/\bAND\b/gi, '&&')
      .replace(/\bOR\b/gi, '||')
  )
  if (!currentExpression) {
    return true
  }
  const orList = splitExpression(currentExpression, '||')
  if (orList.length > 1) {
    return orList.some(item => evaluateVisibilityExpression(item, fieldValueMap))
  }
  const andList = splitExpression(currentExpression, '&&')
  if (andList.length > 1) {
    return andList.every(item => evaluateVisibilityExpression(item, fieldValueMap))
  }
  return evaluateSimpleExpression(currentExpression, fieldValueMap)
}

export function isFieldVisible (field, fields = []) {
  if (!field.visibilityExpr) {
    return true
  }
  return evaluateVisibilityExpression(field.visibilityExpr, getFieldValueMap(fields))
}

export function isRequiredField (field) {
  return field.sourceRequired === true || field.sourceRequired === 1 || field.sourceRequired === 'true' || field.sourceRequired === '1'
}

export function isEmptyFieldValue (field) {
  if (Array.isArray(field.fieldValue)) {
    return field.fieldValue.length === 0
  }
  if (field.controlType === 'NUMBER') {
    return field.fieldValue === '' || field.fieldValue === null || field.fieldValue === undefined
  }
  return String(field.fieldValue === null || field.fieldValue === undefined ? '' : field.fieldValue).trim() === ''
}

export function serializeFieldValue (field) {
  if (field.fieldValue === null || field.fieldValue === undefined) {
    return ''
  }
  if (Array.isArray(field.fieldValue)) {
    return field.fieldValue.join(',')
  }
  const currentValue = String(field.fieldValue).trim()
  const unitOptions = String(field.unit || '').split(',').map(item => item.trim()).filter(Boolean)
  if (unitOptions.length > 1 && currentValue) {
    return `${currentValue}${field._selectedUnit || unitOptions[0]}`
  }
  if (field.controlType === 'NUMBER') {
    return String(field.fieldValue)
  }
  return currentValue
}

export function resolveFieldDisplayValue (field) {
  const currentValue = field.fieldValue
  if (currentValue === '' || currentValue === null || currentValue === undefined) {
    return '-'
  }
  if (field.controlType === 'SINGLE_SELECT') {
    const matched = (field.options || []).find(item => item.code === currentValue)
    return matched ? matched.name : currentValue
  }
  if (field.controlType === 'SWITCH') {
    return currentValue === 'Y' ? '是' : currentValue === 'N' ? '否' : currentValue
  }
  return String(currentValue)
}
